import { client } from './setup';
import { TAGS_API } from '../globals';

export default {
    getTags: (params) => client.get(TAGS_API, { params }),
    getTag: (id) => client.get(`${TAGS_API}/${id}`),
    createTag: (tag) => client.post(TAGS_API, tag),
    updateTag: (tag) => client.put(`${TAGS_API}/${tag.id}`, tag),
    deleteTag: (id) => client.delete(`${TAGS_API}/${id}`),
}